module.exports = __webpack_public_path__ + "static/media/app-fledermaeuse-animated.0883eeb0.gif";